import * as actionTypes from './actionTypes';
import * as actionTypesSidebar from '@app/src/commons/sidebar/state/sidebar/actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  errorMessage: string;
  errorRol: boolean;
}

const initialState: State = {
  data: {
    code: null,
    message: ''
  },
  isFetching: false,
  errorMessage: '',
  errorRol: false
}

export const createUser = (state: State = initialState, action): State => {
  switch(action.type) {
    case actionTypes.FETCH_CREATEUSER_REQUEST:
      return {
        ...state,
        isFetching : true
      };

    case actionTypes.FETCH_CREATEUSER_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
        errorRol: action.errorRol,
        isFetching: false
      };

    case actionTypes.FETCH_CREATEUSER_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: false,
        errorMessage: '',
        errorRol: false
      };

    case actionTypesSidebar.RESET_APP_STATE:
      return initialState;
    default:
      return state;
  }
}
